/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useState, useEffect, Fragment} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import Modal from 'antd/lib/modal';
import UploadProof from '../../components/UploadProof/index.tsx';

import TextAreaFormItem from '../../components/TextAreaFormItem/index.tsx';
import AgreeProtocol from '../../components/AgreeProtocol/index.tsx';
import QuestionPageTip from './questionPageTip';
import NumFeedback from './numFeedback';
import NoNumFeedback from './noNumFeedback';
import SubmitSuccess from './step2';

// import secm from '@baidu/sec-monitor';

import {
    feedbackTip
} from '../../components/UploadProof/uploadTip.tsx';
import {recordProxy, bCat_2055_request, getQueryString, checkNumber} from '../../util';

import {Button, message} from 'antd';

const FeedbackStep = (props) => {
    const {datatype, fetchV1Search} = props;
    const [curStep, setCurStep] = useState(1);
    const [phone, setPhone] = useState({
        phone: [],
        phoneErr: ''
    });
    const [noNumdata, setNoNumdata] = useState({});
    const [questionType, setQuestionType] = useState({
        questionType: '',
        questionTypeErr: ''
    });
    const [noNumObj, setNoNumObj] = useState({
        noNumValue: {},
        noNumValueErr: ''
    });
    const [desc, setDesc] = useState({
        desc: '',
        descErr: ''
    });
    const [image, setImage] = useState({
        image: [],
        imageErr: ''
    });

    const [isRead, setIsRead] = useState({
        isRead: false,
        isReadErr: ''
    });
    const [phoneList, setPhoneList] = useState([]);

    useEffect(() => {
        const searchUrl = getQueryString('phones');
        const srcid = getQueryString('srcid');
        const search = getQueryString('search');
        if (search && datatype === '1') {
            getSearchInfo(decodeURIComponent(search), datatype);
        }
        // 8952资源存在多个号码相同的情况，直接显示输入框
        if (searchUrl && srcid !== '8952') {
            try {
                const phoneListTemp = JSON.parse(decodeURIComponent(getQueryString('phones'))) || [];
                setPhoneList(phoneListTemp);
            } catch (e) {
                console.log(e);
            }
        }

    }, [location.search, getQueryString]);

    const getSearchInfo = (search, datatype) => {
        const fetchParam = {
            search: search,
            datatype
        };
        const fetchSearch = (params) => fetchV1Search({
            ...params,
            ...fetchParam
        }).then(res => {
            if (res) {
                const data = res.data;
                if (data && data[search]) {
                    setNoNumdata(data[search].customer[0]);
                }
            }
        });
        bCat_2055_request(fetchSearch);
    };

    async function verifyCheck(value, type, updateType) {
        if (type === 'noNumValue') {
            const valueKeys = Object.keys(value[type]);
            if (valueKeys.length === 0) {
                updateType({
                    ...value,
                    [type + 'Err']: '不能为空'
                });
                return false;
            }
        }
        if (!value[type] || (type === 'phone' && !value[type].length)) {
            updateType({
                ...value,
                [type + 'Err']: '不能为空'
            });
            return false;
        }
        if (phoneList.length === 0 && type === 'phone' && !checkNumber(value.phone[0])) {
            // phoneList有值代表从阿拉丁卡过来的，不校验
            updateType({
                ...value,
                phoneErr: '号码格式不正确'
            });
            return false;
        }
        updateType({
            ...value,
            [type + 'Err']: ''
        });
        return true;
    }
    async function verifyUploadCheck(value, type, updateType) {
        if (!value[type + 'Err']?.length) {
            updateType({
                ...value,
                [type + 'Err']: ''
            });
            return true;
        }
    }

    async function nextClick() {
        let errPhone = await verifyCheck(phone, 'phone', setPhone);
        let errQuestionType = await verifyCheck(questionType, 'questionType', setQuestionType);
        let errDesc = questionType.questionType === 3 ? await verifyCheck(desc, 'desc', setDesc) : true;

        const errIsRead = await verifyCheck(isRead, 'isRead', setIsRead);
        const errImage = await verifyUploadCheck(image, 'image', setImage);

        if (datatype === '1' || datatype === '2') {
            errPhone = await verifyCheck(noNumObj, 'noNumValue', setNoNumObj);
            errQuestionType = true;
            errDesc = noNumObj.noNumValue.other === '1' ? await verifyCheck(desc, 'desc', setDesc) : true;
        }

        if (errPhone && errQuestionType && errDesc && errIsRead && errImage) {
            recordProxy('submit', phone.phone + '', questionType.questionType + '');

            let json = {
                phone: phone.phone,
                'topic_type': questionType.questionType,
                content: desc.desc,
                'img_id': image.image.length ? image.image.map(item => item.id)[0] : 0,
                is_read: 1,
                datatype: datatype,
            };
            if (datatype === '1' || datatype === '2') {
                json.feedback_detail = noNumObj.noNumValue;
                json.topic_type = -1;
            }
            const fetchCreateTopic = (params) => props.fetchCreateTopic({
                ...json,
                ...params
            }).then(data => {
                if (data?.code === 200) {
                    setCurStep(2);
                } else if (data?.code === 401) {
                    Modal.info({
                        title: '结果提示',
                        okText: '知道了',
                        content: (
                            <div>
                                <p>未查询到该号码，如有疑问请添加QQ群725854778，私聊管理员处理。</p>
                            </div>
                        ),
                        onOk() {},
                    });
                } else if (data?.code === 402) {
                    Modal.info({
                        title: '结果提示',
                        okText: '知道了',
                        content: (
                            <div>
                                <p>号码不可重复提交，如有疑问，请添加QQ群725854778，私信管理员处理。</p>
                            </div>
                        ),
                        onOk() {},
                    });
                } else {
                    message.error(data?.message);
                }
            });
            bCat_2055_request(fetchCreateTopic);
        }
    }
    const noNumChangeCallback = (value) => {
        setNoNumObj({
            noNumValue: value,
            noNumValueErr: ''
        });
        setDesc({
            ...desc,
            descErr: ''
        });
    };

    return (
        <div className="feedback-major-step">
            {curStep === 1 && <Fragment>
                {datatype === '1' || datatype === '2'
                    ? <div>
                        <NoNumFeedback
                            noNumChangeCallback={noNumChangeCallback}
                            datatype={datatype}
                            noNumObj={noNumObj}
                            data={noNumdata}
                        />
                    </div>
                    : <Fragment>
                        <QuestionPageTip props={props}></QuestionPageTip>
                        <NumFeedback
                            phoneList={phoneList}
                            phone={phone}
                            setPhone={setPhone}
                            // curStep={curStep}
                            desc={desc}
                            setDesc={setDesc}
                            questionType={questionType}
                            setQuestionType={setQuestionType}
                        />
                    </Fragment>
                }
                <TextAreaFormItem
                    title="问题说明"
                    isMsgRequired={questionType.questionType === 3 || noNumObj.noNumValue.other === '1'}
                    placeholder="请详细说明问题，以便我们定位与解决"
                    type="desc"
                    maxLength={40}
                    data={desc}
                    onChange={e => setDesc({
                        ...desc,
                        desc: e.target.value,
                        descErr: ''
                    })}
                    onBlur={e => setDesc({
                        ...desc,
                        desc: e.target.value,
                        descErr: ''
                    })}
                    style={{width: '424px'}}
                />
                <UploadProof
                    title="问题截图"
                    isMsgRequired={false}
                    type="image"
                    maxImgLength={1}
                    data={image}
                    onChange={obj => setImage(obj)}
                    tips={feedbackTip()}
                />
                <AgreeProtocol
                    type="isRead"
                    data={isRead}
                    onChange={e => {
                        setIsRead({
                            isRead: e.target.checked,
                            isReadErr: ''
                        });
                    }}
                />
                <div className="btn-content">
                    <Button
                        className="btn-step1-primary"
                        type="primary"
                        onClick={nextClick}
                    >
                        提交
                    </Button>
                </div>
            </Fragment>}
            {curStep === 2 && <Fragment>
                <SubmitSuccess
                    listUrl="/user_center/my_feedback"
                />
            </Fragment>}
        </div>
    );
};

FeedbackStep.propTypes = {
    fetchCreateTopic: PropTypes.func,
    fetchV1Search: PropTypes.func,
    datatype: PropTypes.string,
};

export default withRouter(FeedbackStep);
